import React from 'react';
import { useEffectOnce } from 'react-use';
import { Route, Router, Switch, Redirect } from 'react-router-dom'; // Switch, Redirect
import { createBrowserHistory } from 'history';
import loadable from '@loadable/component';
import { connect } from 'react-redux';
import Main from '../Layouts/Main';
import { localeList } from '../../utils/Helper';
import store from '../../redux/store';
import { getSiteConfig } from '../../redux/modules/siteConfig/action';
import { getCustomSettings } from '../../redux/modules/customSettings/action';


import c from '../../config';

// Default Style
import '../../assets/scss/theme.scss';

// cookie
const CookieConsent = loadable(() => import('../../components/CookieConsent'));

// SSO
const SSOStatus = loadable(() => import('../../components/SSOStatus'));

// Routes
const HomePage = loadable(() => import('../../pages/HomePage'));
const WhatsNewPage = loadable(() => import('../../pages/WhatsNewPage'));
const UpcomingPage = loadable(() => import('../../pages/UpcomingPage'));
const UpcomingDetailsPage = loadable(() => import('../../pages/UpcomingDetailsPage'));
const ShowsPage = loadable(() => import('../../pages/ShowsPage'));
const ShowsDetailsPage = loadable(() => import('../../pages/ShowsDetailsPage'));
const DesignersPage = loadable(() => import('../../pages/DesignersPage'));
const PressPage = loadable(() => import('../../pages/PressPage'));
const PressDetailsPage = loadable(() => import('../../pages/PressDetailsPage'));
const RoadmapPage = loadable(() => import('../../pages/RoadmapPage'));
const ContactPage = loadable(() => import('../../pages/ContactPage'));
const DesignersDetailsPage = loadable(() => import('../../pages/DesignersDetailsPage'));
const NoMatch = loadable(() => import('../../pages/NoMatch'));
const ComingSoonPage = loadable(() => import('../../pages/ComingSoonPage'));
const SearchPage = loadable(() => import('../../pages/SearchPage'));
const StaticPage = loadable(() => import('../../pages/StaticPage'));

// Config Top Application, include languages
const TopApp = loadable(() => import('../../widgets/TopApp'));

const history = createBrowserHistory();

const App = ({ ...props }) => {
  const { siteConfig } = props;
  const { data = {} } = siteConfig || {};
  const { availableLanguages, defaultLanguage, enableSSO, under_construction } = data;
  const isUnderConstruction = under_construction === 'true' || under_construction === true;

  useEffectOnce(() => {
    store.dispatch(getSiteConfig());
    store.dispatch(getCustomSettings());
  });

  return (
    <>
      <CookieConsent />
      {enableSSO && <SSOStatus />}
      {availableLanguages && (
        <Router history={history} basename={c.routePathTo}>
          <Route
            path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})?`}
            component={TopApp}
          />
          <Main
            availableLanguages={localeList(availableLanguages)}
            isUnderConstruction={isUnderConstruction}
          >
            <Switch>
              {isUnderConstruction && <Route component={ComingSoonPage} />}
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})?`}
                render={(props) => <HomePage {...props} />}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})?/whatsnew`}
                component={WhatsNewPage}
                name="Whats New"
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})?/upcoming`}
                component={UpcomingPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(
                  availableLanguages,
                )})?/upcoming/:fashionweek/:upcomingID`}
                component={UpcomingDetailsPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(
                  availableLanguages,
                )})?/shows/:showsYear?/:tag?`}
                component={ShowsPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(
                  availableLanguages,
                )})?/shows/fashionweek/:showsName/:showID/:brandName?`}
                component={ShowsDetailsPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})?/designers`}
                component={DesignersPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(
                  availableLanguages,
                )})?/designers/:name/:designerID`}
                component={DesignersDetailsPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})?/press/:pressYear?`}
                component={PressPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})?/press/detail/:pressID`}
                component={PressDetailsPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})?/roadmap`}
                component={RoadmapPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})?/contact`}
                component={ContactPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})?/search`}
                component={SearchPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/s/:pageName`}
                component={StaticPage}
              />
              <Route component={NoMatch} />
            </Switch>
          </Main>
        </Router>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(App);

export { App as AppComponent }; // <- For component Unit Test
export default connectStore;
